import { connect } from 'react-redux';
import {
    fetchValidatePendingAccreditation,
    getPendingAccreditationDataFormatted,
    fetchDiscardPendingAccreditation
} from './../../../reducers/applicantAccreditations/pendingAccreditations';
import ValidatePendingAccreditation from './ValidatePendingAccreditation';
import { getCurrentContinent, setCurrentContinent, getCountriesData, getContinentsData } from './../../../reducers/common/location';
import { fetchGetLevels, getLevelsData } from './../../../reducers/common/levels';
import { getTranslation } from "../../../reducers/common/localization";
import { setCurrentContinentByCountry } from "../../../reducers/common/location";
import { MODAL_VALIDATE_PENDING_ACCREDITATION, showModal, MODAL_DISCARD_PENDING_ACCREDITATION } from "../../../reducers/common/activeModal";
import { Utils } from './../../../utils/utils';
import { getSubmitFormSuccessStatus } from './../../../reducers/common/submitForm';
import { isVIDEditable, fetchGetVIDs } from './../../../reducers/applicantAccreditations/VIDs';

const mapStateToProps = (state, { location }) => {
    let searchParams = Utils.getParamsFromLocationSearch(location.search);
    return {
        id: searchParams.id,
        success: getSubmitFormSuccessStatus(state),
        data: getPendingAccreditationDataFormatted(state, searchParams.id),
        isVIDEditable: isVIDEditable(state, searchParams.id),
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state),
        levels: getLevelsData(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSubmit: (id, data) => {
            dispatch(fetchValidatePendingAccreditation(id, data));
        },
        onDiscard: (id) => {
            dispatch(fetchDiscardPendingAccreditation(id));
        },        
        onContinentSetByCountry: (countryCode) => {
            dispatch(setCurrentContinentByCountry(countryCode));
        },
        onContinentSet: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        onGetLevels: () => {
            dispatch(fetchGetLevels());
        },
        onGetVIDs: () => {
            dispatch(fetchGetVIDs());
        },
        onOpenValidatePendingAccreditationModal: () => dispatch(showModal({ modalKey: MODAL_VALIDATE_PENDING_ACCREDITATION })),
        onOpenDiscardPendingAccreditationModal: () => dispatch(showModal({ modalKey: MODAL_DISCARD_PENDING_ACCREDITATION }))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidatePendingAccreditation);



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/validatePendingAccreditation/ValidatePendingAccreditation.container.js